import React, { ReactNode } from 'react';

import {
  TableContainer,
  Table as TableEmotion,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Separator
} from './styles';
export interface TableProps {
  children: ReactNode;
}

export interface ItemButtonProps {
  children: ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
}

export interface SeparatorProps {
  children: ReactNode;
  colSpan: number;
}

export function Table(props: TableProps) {
  const { children } = props;
  return (
    <TableContainer>
      <TableEmotion>{children}</TableEmotion>
    </TableContainer>
  );
}

Table.Head = (props: TableProps) => {
  return (
    <Thead>
      <tr>{props.children}</tr>
    </Thead>
  );
};

Table.Body = Tbody;
Table.Row = Tr;
Table.Label = Th;
Table.Cell = Td;
Table.Separator = (props: SeparatorProps) => (
  <tr>
    <Separator colSpan={props.colSpan}>{props.children}</Separator>
  </tr>
);
